<template>
  <!-- cod. tag -->
  <div class="md:col-span-1">
    <BaseInput
      type="text"
      name="itensForm.values.cod_tag"
      v-model="store.itensForm.values.cod_tag"
      :info="'Cod. / Tag'"
      label="Cod. / Tag"
      :required-field="false"
      :activeDefault="false"
    >
      <template #append>
        <CleanInputButton @click="store.itensForm.values.cod_tag = undefined" />
      </template>
    </BaseInput>
  </div>

  <!-- estado caixa -->
  <div class="md:col-span-2">
    <div class="md:col-span-2 mt-1.5">
      <label class="text-left flex pl-1 text-xs text-[#2b3038]" for="form.type">
        Estado físico
      </label>
      <div class="h-10 flex rounded items-center">
        <SimpleSelect
          class="px-1 py-2 appearance-none outline-none text-gray-800 w-full bg-transparent"
          :data="light.estado_caixa"
          :initialValue="store.itensForm.values.estado_caixa"
          @selected-data="(val) => (store.itensForm.values.estado_caixa = val)"
        />
      </div>
    </div>
  </div>

  <!-- estado caixa desc -->
  <Transition mode="out-in">
    <div class="md:col-span-2" v-if="store.itensForm.values.estado_caixa?.value == 'inadequado'">
      <BaseInput
        type="text"
        name="itensForm.values.peso"
        v-model="store.itensForm.values.estado_caixa_descript"
        :info="'Inadequação física'"
        label="Danificado, quebrado..."
        :required-field="true"
        :activeDefault="true"
      >
        <template #append>
          <CleanInputButton @click="store.itensForm.values.estado_caixa_descript = undefined" />
        </template>
      </BaseInput>
    </div>
  </Transition>

  <!-- obstru -->
  <div class="md:col-span-1">
    <div class="md:col-span-2 mt-1.5">
      <label class="text-left flex pl-1 text-xs text-[#2b3038]" for="form.type">
        Livre de obstrução
      </label>
      <div class="h-10 flex rounded items-center">
        <SimpleSelect
          class="px-1 py-2 appearance-none outline-none text-gray-800 w-full bg-transparent"
          :data="light.obstru"
          :initialValue="store.itensForm.values.obstru"
          @selected-data="(val) => (store.itensForm.values.obstru = val)"
        />
      </div>
    </div>
  </div>

  <!-- obstru -->
  <Transition mode="out-in">
    <div class="md:col-span-2" v-if="store.itensForm.values.obstru?.value == 'nao'">
      <BaseInput
        type="text"
        name="itensForm.values.peso"
        v-model="store.itensForm.values.obstru_descript"
        :info="'Informe a obstrução'"
        label="Não visivel, não identificavél..."
        :required-field="true"
        :activeDefault="true"
      >
        <template #append>
          <CleanInputButton @click="store.itensForm.values.obstru_descript = undefined" />
        </template>
      </BaseInput>
    </div>
  </Transition>

  <!-- tomada -->
  <div class="md:col-span-2">
    <div class="md:col-span-2 mt-1.5">
      <label class="text-left flex pl-1 text-xs text-[#2b3038]" for="form.type">
        Fonte de alimentação
      </label>
      <div class="h-10 flex rounded items-center">
        <SimpleSelect
          class="px-1 py-2 appearance-none outline-none text-gray-800 w-full bg-transparent"
          :data="light.tom_energia"
          :initialValue="store.itensForm.values.tom_energia"
          @selected-data="(val) => (store.itensForm.values.tom_energia = val)"
        />
      </div>
    </div>
  </div>

  <!-- tomada obs -->
  <Transition mode="out-in">
    <div class="md:col-span-2" v-if="store.itensForm.values.tom_energia?.value == 'inadequado'">
      <BaseInput
        type="text"
        name="itensForm.values.peso"
        v-model="store.itensForm.values.tom_energia_descript"
        :info="'Informe inadequação'"
        label="Danificada, não funcional..."
        :required-field="true"
        :activeDefault="true"
      >
        <template #append>
          <CleanInputButton @click="store.itensForm.values.tom_energia_descript = undefined" />
        </template>
      </BaseInput>
    </div>
  </Transition>

  <!-- Funcionamwnto -->
  <div class="md:col-span-2">
    <div class="md:col-span-2 mt-1.5">
      <label class="text-left flex pl-1 text-xs text-[#2b3038]" for="form.type">
        Funcionamento
      </label>
      <div class="h-10 flex rounded items-center">
        <SimpleSelect
          class="px-1 py-2 appearance-none outline-none text-gray-800 w-full bg-transparent"
          :data="light.funcionamento"
          :initialValue="store.itensForm.values.funcionamento"
          @selected-data="(val) => (store.itensForm.values.funcionamento = val)"
        />
      </div>
    </div>
  </div>

  <!-- funcionamento obs -->
  <Transition mode="out-in">
    <div class="md:col-span-2" v-if="store.itensForm.values.funcionamento?.value == 'inadequado'">
      <BaseInput
        type="text"
        name="itensForm.values.peso"
        v-model="store.itensForm.values.funcionamento_descript"
        :info="'Status de funcionamento'"
        label="Não funcional, danificado..."
        :required-field="true"
        :activeDefault="true"
      >
        <template #append>
          <CleanInputButton @click="store.itensForm.values.funcionamento_descript = undefined" />
        </template>
      </BaseInput>
    </div>
  </Transition>

  <!-- leds -->
  <div class="md:col-span-2">
    <div class="md:col-span-2 mt-1.5">
      <label class="text-left flex pl-1 text-xs text-[#2b3038]" for="form.type">
        Led de carregamento/comunicação
      </label>
      <div class="h-10 flex rounded items-center">
        <SimpleSelect
          class="px-1 py-2 appearance-none outline-none text-gray-800 w-full bg-transparent"
          :data="light.funcionamento"
          :initialValue="store.itensForm.values.leds"
          @selected-data="(val) => (store.itensForm.values.leds = val)"
        />
      </div>
    </div>
  </div>

  <!-- leds -->
  <Transition mode="out-in">
    <div class="md:col-span-2" v-if="store.itensForm.values.leds?.value == 'inadequado'">
      <BaseInput
        type="text"
        name="itensForm.values.peso"
        v-model="store.itensForm.values.leds_descript"
        :info="'Inadequação da led'"
        label="Não funcional, danificado..."
        :required-field="true"
        :activeDefault="true"
      >
        <template #append>
          <CleanInputButton @click="store.itensForm.values.leds_descript = undefined" />
        </template>
      </BaseInput>
    </div>
  </Transition>

  <!-- botão teste -->
  <div class="md:col-span-2">
    <div class="md:col-span-2 mt-1.5">
      <label class="text-left flex pl-1 text-xs text-[#2b3038]" for="form.type">
        Botão de teste
      </label>
      <div class="h-10 flex rounded items-center">
        <SimpleSelect
          class="px-1 py-2 appearance-none outline-none text-gray-800 w-full bg-transparent"
          :data="light.funcionamento"
          :initialValue="store.itensForm.values.btn_test"
          @selected-data="(val) => (store.itensForm.values.btn_test = val)"
        />
      </div>
    </div>
  </div>

  <!-- botão teste -->
  <Transition mode="out-in">
    <div class="md:col-span-2" v-if="store.itensForm.values.btn_test?.value == 'inadequado'">
      <BaseInput
        type="text"
        name="itensForm.values.peso"
        v-model="store.itensForm.values.btn_test_descript"
        :info="'Inadequação do botão'"
        label="Não funcional, danificado..."
        :required-field="true"
        :activeDefault="true"
      >
        <template #append>
          <CleanInputButton @click="store.itensForm.values.btn_test_descript = undefined" />
        </template>
      </BaseInput>
    </div>
  </Transition>

  <!-- tipo de iluminação -->
  <div class="md:col-span-2">
    <div class="md:col-span-2 mt-1.5">
      <label class="text-left flex pl-1 text-xs text-[#2b3038]" for="form.type">
        Tipo de iluminação
      </label>
      <div class="h-10 flex rounded items-center">
        <SimpleSelect
          class="px-1 py-2 appearance-none outline-none text-gray-800 w-full bg-transparent"
          :data="light.ilum_type"
          :initialValue="store.itensForm.values.ilum_type"
          @selected-data="(val) => (store.itensForm.values.ilum_type = val)"
        />
      </div>
    </div>
  </div>
</template>

<script setup>
import CleanInputButton from '../../utils/CleanInputButton.vue'
import SimpleSelect from '@/components/Select/SimpleSelect.vue'
import BaseInput from '@/components/Inputs/BaseInput.vue'
import { dataExtinguisher } from '../../store'
import { light } from '../../lookups/form'

const store = dataExtinguisher.state

</script>
